module.exports = __webpack_public_path__ + "static/media/take0Points_1.67ba6f16.png";